﻿import { ready } from "./ready";
import { resourceSet } from "./res";
import { addCallback, runCallbacks } from "./asyncViews";

import { catchup, initForm, initDeps, setFocus, addInitControl } from "./dynrefresh";

export const TD = {
	ready,
	addCallback: ready,
	Res: resourceSet,
	AsyncViews: {
		addCallback,
		runCallbacks
	},
	Ctrl: {
		initForm,
		initDeps,
		catchup,
		addInitControl,
		setFocus
	}
};